import { handleGeneratorRequest, type GeneratorResponse } from '../../game/worker-protocol';
import {
  createGeneratorClient,
  type GeneratorClient,
  type GeneratorWorker,
} from './generator-client';

function createInlineFallback(): GeneratorWorker {
  const listeners = new Set<(event: MessageEvent<GeneratorResponse>) => void>();
  let terminated = false;
  return {
    postMessage(message) {
      queueMicrotask(() => {
        handleGeneratorRequest(message, (response) => {
          if (!terminated) {
            const event = new MessageEvent<GeneratorResponse>('message', { data: response });
            listeners.forEach((listener) => listener(event));
          }
        });
      });
    },
    addEventListener(_type, listener) {
      listeners.add(listener);
    },
    terminate() {
      terminated = true;
      listeners.clear();
    },
  };
}

export function createBrowserGenerator(): GeneratorClient {
  return createGeneratorClient(() => {
    if (typeof Worker === 'undefined') {
      return createInlineFallback();
    }
    return new Worker(new URL('../../game/generator.worker.ts', import.meta.url), {
      type: 'module',
      name: 'sudoku-generator',
    });
  });
}
